// export const tiptapValueEmpty = (value) => {
//     try {
//         return !value?.content || // Проверяем, существует ли content
//             value.content.length === 0 || // Если массив пустой
//             value.content.every(item => !item?.content || !item.content[0]?.text?.trim()) // Проверяем, что все элементы не заполнены
//     } catch (error) {
//         return false
//     }
// }

export const tiptapValueEmpty = (value) => {
    try {
        if (!value?.content || value.content.length === 0) {
            return true;
        }

        const hasActualContent = (node) => {
            if (node.text && node.text.trim()) {
                return true;
            }
            
            // Проверяем на наличие других узлов (изображения, видео и т.д.)
            // Узлы с типом, отличным от 'paragraph' или 'text', считаются контентом
            if (node.type && !['paragraph', 'text'].includes(node.type)) {
                return true;
            }
            
            // Рекурсивно проверяем вложенный контент
            if (node.content && Array.isArray(node.content)) {
                return node.content.some(hasActualContent);
            }
            
            return false;
        };

        // Проверяем, есть ли хоть какой-то реальный контент
        return !value.content.some(hasActualContent);
    } catch (error) {
        return false;
    }
};